<template>
    <section class="city-entire-box">
        <p class="city-type-letter" v-text="letter"></p>
        <div class="city-letter-list">
            <div class="city-letter" v-for="list in lists" @click="selectCity(list.ShortName, list.Name)">
                <span v-text="list.Name"></span>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: '',
        data () {
            return {

            }
        },
        methods: {
            selectCity (shortName, cityName) {
                this.$emit('selectCity', shortName, cityName)
            }
        },
        props: {
            letter: {},
            lists: {}
        }
    }
</script>

<style lang="scss" scoped>
    .city-entire-box {
        background: #ffffff;
        .city-type-letter {
            padding: j(0) j(50);
            height: j(50);
            line-height: j(50);
            font-size: j(24);
            // color: #999999;
            color: #9B9DA9;
            // background: #f5f5f5;
            background: #f0f1f2;
        }
        .city-letter-list {
            padding: j(0) j(50);
            background: #ffffff;
            .city-letter {
                padding: j(35) 0;
                position: relative;
                @extend %bb1;
            }
            .city-letter:last-child:after {
                background: transparent;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/cityLetterList.vue